import { useEffect } from 'react';
import { useChatContext } from 'src/provider/ChatContext';
import { useSelector } from 'src/redux/store';
import { ChatConversation } from 'src/sections/@dashboard/chat/ChatConversation';

type Props = {
  onClose(): void;
};

export const ChatActionBar = ({ onClose }: Props) => {
  const { currentActiveChat, isDrawer } = useChatContext();
  const conversation = useSelector(
    (state) => state.chat.conversations.byId[currentActiveChat],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!isDrawer) {
      onClose();
    }
  }, [isDrawer]);

  if (!currentActiveChat) return null;

  return (
    <ChatConversation
      conversation={conversation}
      isModal={false}
      onClose={onClose}
    />
  );
};
